import { Head, router } from "@inertiajs/react"
import { Button, Container, Flex, Heading, Section } from "@radix-ui/themes"
import { Plus } from "lucide-react"
import TracksTable from "@/shared/admin/TracksTable"
import { AdminTrack } from "@/types/shared"

interface Props {
  tracks: AdminTrack[]
}

export default function AdminTracksIndex({ tracks }: Props) {
  const handleRowClick = (track: AdminTrack) => {
    router.get(`/tracks/${track.slug}/edit`)
  }

  const handleNewTrack = () => {
    router.get("/tracks/new")
  }

  return (
    <div className="flex">
      <Head title="Tracks - Admin" />
      <div className="grow">
        <Section>
          <Container size="4">
            <Flex justify="between" align="center" mb="6">
              <Heading size="7">Tracks</Heading>
              <Button onClick={handleNewTrack}>
                <Plus size={18} />
                New Track
              </Button>
            </Flex>
            <TracksTable tracks={tracks} onRowClick={handleRowClick} />
          </Container>
        </Section>
      </div>
    </div>
  )
}
